/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-02-24 18:04:33
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-15 10:54:42
 */
export const queryPage = '/icps/system/sign/intelligent/warehouse/return/queryPage'
export const saveOrUpdate = '/icps/system/sign/intelligent/warehouse/return/saveOrUpdate'
import request from '@/utils/request'
/**获取特材名称列表*/
export function updataData(data) {
  return request({
    url: '/icps/system/sign/intelligent/warehouse/return/saveOrUpdate',
    method: 'post',
    data
  })
}
export function productList(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/product/queryPage',
    method: 'post',
    data
  })
}
/**获取车辆*/
export function carList(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/car/queryPage',
    method: 'post',
    data
  })
}
/**派车*/
export function sendCar(data) {
  return request({
    url: '/icps/system/sign/intelligent/warehouse/return/sendCar',
    method: 'post',
    data
  })
}
/**返料运输*/
export function shipping(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/shipping/queryPage',
    method: 'post',
    data
  })
}
/**返料运输*/
export function checkNum(data) {
  return request({
    url: '/icps/system/sign/intelligent/warehouse/return/checkNum',
    method: 'post',
    data
  })
}
/**液位仪数据字典*/
export function queryMeterList(data) {
  return request({
    url: '/icps/system/sign/intelligent/warehouse/meter/queryMeterList',
    method: 'post',
    data
  })
}
/**返料运输删除*/
export function deleteTask(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/shipping/deleteTask',
    method: 'get',
    params
  })
}